import { useRef } from 'react';

// Lets mouse users click-and-drag to scroll a horizontally overflowing
// container, mirroring the swipe touch and trackpad users already get for
// free. Mouse wheels only scroll vertically and the scrollbar is usually
// hidden, so without this a mouse-only desktop user has no way to reach the
// overflow.
export function useDragToScroll() {
  const drag = useRef({ active: false, moved: false, startX: 0, startScrollLeft: 0 });

  const scrollHorizontally = (e) => {
    const el = e.currentTarget;
    if (e.deltaY === 0 || el.scrollWidth <= el.clientWidth) {
      return;
    }
    el.scrollLeft += e.deltaY;
    e.preventDefault();
  };

  const startDrag = (e) => {
    const el = e.currentTarget;
    if (e.pointerType !== 'mouse' || e.button !== 0 || el.scrollWidth <= el.clientWidth) {
      return;
    }
    drag.current = { active: true, moved: false, startX: e.clientX, startScrollLeft: el.scrollLeft };
    el.setPointerCapture(e.pointerId);
  };

  const duringDrag = (e) => {
    if (!drag.current.active) {
      return;
    }
    const delta = e.clientX - drag.current.startX;
    if (Math.abs(delta) > 3) {
      drag.current.moved = true;
    }
    e.currentTarget.scrollLeft = drag.current.startScrollLeft - delta;
  };

  const endDrag = (e) => {
    if (!drag.current.active) {
      return;
    }
    drag.current.active = false;
    e.currentTarget.releasePointerCapture(e.pointerId);
  };

  // A drag ending on a pill fires a click there same as a real click would,
  // so swallow it once the pointer has actually moved -- otherwise every
  // drag-to-scroll also toggles whichever pill was under the cursor.
  const suppressClickAfterDrag = (e) => {
    if (drag.current.moved) {
      drag.current.moved = false;
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return {
    onWheel: scrollHorizontally,
    onPointerDown: startDrag,
    onPointerMove: duringDrag,
    onPointerUp: endDrag,
    onPointerCancel: endDrag,
    onClickCapture: suppressClickAfterDrag,
  };
}
